import { render, staticRenderFns } from "./StatsCharts.vue?vue&type=template&id=72822eb0&"
import script from "./StatsCharts.vue?vue&type=script&lang=js&"
export * from "./StatsCharts.vue?vue&type=script&lang=js&"
import style0 from "./StatsCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports